import React, { useState } from 'react'
import logo from "../../assets/boxxdocks-logo-grey.svg"
import { useDispatch, useSelector } from "react-redux";
import { setStateRefresh } from "../../redux/globalSlice";

const EnterDetails = () => {
  const dispatch = useDispatch();
  const stateRefresh = useSelector((state) => state.global.stateRefresh);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const isValidEmail = (email) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  };

  const submitHandler = () => {
    if (!email.trim()) {
      setEmailError("Email is required.");
      return;
    }
    if (!isValidEmail(email.trim())) {
      setEmailError("Please enter a valid email address.");
      return;
    }
    setEmailError("");
    localStorage.setItem("serviceFirstName", firstName);
    localStorage.setItem("serviceLastName", lastName);
    localStorage.setItem("serviceEmail", email);
     localStorage.setItem("serviceAnonymous", false);
    localStorage.setItem("getServicePage", "AddComment");

    dispatch(setStateRefresh(!stateRefresh));
  };
  const handleAnonymous = () => {
    localStorage.setItem("serviceAnonymous", true);
    localStorage.setItem("getServicePage", "AddComment");
    dispatch(setStateRefresh(!stateRefresh));
  };


  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <div className="main-content">
            <div className="logo mx-auto">
              <img src={logo} className="img-fluid mx-auto" alt="" />
            </div>
            <p className="mb-0 heading">Enter your Name?</p>

            <div className="code-box">
              <form>
                <div className="form-one mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="code"
                    placeholder="Enter First Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>

                <div className="form-one mb-3">
                  <label htmlFor="exampleInputPassword1" className="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="code"
                    placeholder="Enter Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>

                <div className="form-one">
                  <label htmlFor="exampleInputPassword1" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className="code"
                    placeholder="Enter Email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setEmailError('');
                    }}
                  />
                  {emailError && (
                    <p style={{ color: 'red', marginTop: 5, marginLeft: 5 }}>{emailError}</p>
                  )}
                </div>
                <div className="button-box">
                  <div className="position-absolute">
                    <button type="button" className="btn-skip-s me-4" onClick={handleAnonymous}>Submit Anonymously</button>
                    <button type="button" className="btn-continue-s" onClick={submitHandler} >continue</button>

                  </div>
                </div>
              </form>

            </div>



          </div>
        </div>
      </div>
    </div>
  )
}

export default EnterDetails